var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"focus:outline-none outline-none arrow-button active:text-br-green",class:{
    'pointer-events-none opacity-10 hover:text-black': _vm.arrowDisabled,
    'lg:hover:text-br-green': !_vm.arrowDisabled,
    'text-white': _vm.inverted
  },attrs:{"type":"button","disabled":_vm.arrowDisabled},on:{"&touchstart":function($event){return _vm.doNothing.apply(null, arguments)},"click":function($event){$event.preventDefault();return _vm.$emit('click', _vm.direction)}}},[_c('ArrowIcon',{staticClass:"transition-all h-5",class:_vm.direction === 'right' ? 'rotate-180' : null})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }